'use client'

import ProcessContent from '@/shared/components/process/ProcessContent'
import ProcessFooter from '@/shared/components/process/ProcessFooter'
import ProcessHeader from '@/shared/components/process/ProcessHeader'
import SectionBar from '@/shared/components/SectionBar'
import { Caption, Text } from '@/shared/components/typography'
import type { ChangeEvent, ReactNode } from 'react'

interface PaymentMethod {
  id?: string
  name?: string
  value: string
  checked: boolean
}

interface PaymentInfo {
  key: ReactNode
  value: ReactNode
}

interface PurchasePaymentProps {
  ticketName: ReactNode
  paymentInfo?: PaymentInfo[]
  price: number
  paymentMethods: PaymentMethod[]
  onChangePaymentMethod: (event: ChangeEvent<HTMLInputElement>) => void
  onClickBack: () => void
  onCloseClick: () => void
  onClickPayment: () => void
  title?: string
  buttonText?: string
}

const PurchasePayment = ({
  ticketName,
  paymentInfo = [],
  price,
  paymentMethods,
  onChangePaymentMethod,
  onClickBack,
  onCloseClick,
  onClickPayment,
  title = '결제하기',
  buttonText
}: PurchasePaymentProps) => {
  const formattedPrice = price.toLocaleString()
  const footerText = buttonText ?? `${formattedPrice}원 결제하기`

  return (
    <div className="flex flex-col w-full h-full">
      <ProcessHeader title={title} onBackClick={onClickBack} onCloseClick={onCloseClick} />
      <ProcessContent className="flex flex-col last:gap-0">
        <div className="px-4 py-6">
          <Text level="text1" color="text090" weight="bold">
            {ticketName}
          </Text>
          <div className="mt-3 flex flex-col gap-[10px]">
            {paymentInfo.map((row, index) => (
              <div key={index} className="flex justify-between">
                <Caption level="caption1" color="text070">
                  {row.key}
                </Caption>
                <Caption level="caption1" color="text090">
                  {row.value}
                </Caption>
              </div>
            ))}
          </div>
        </div>
        <SectionBar className="h-[8px]" />
        <div className="flex flex-col items-center w-full py-6">
          <div className="flex items-center justify-between w-full px-4 cursor-pointer">
            <Text level="text3" color="text090" weight="bold">
              결제 금액
            </Text>
            <div className="flex items-center gap-2">
              <Text level="text3" color="text090" weight="bold">
                {formattedPrice}원
              </Text>
            </div>
          </div>
        </div>
        <SectionBar />
        <div className="flex flex-col gap-6 px-4 py-6">
          <Text level="text3" color="text090" weight="bold">
            결제 수단 선택
          </Text>
          <div className="flex flex-col w-full gap-4">
            {paymentMethods.map((payment, index) => (
              <label key={index} className="flex items-center cursor-pointer text-17 leading-26 text-text-090">
                <input
                  className={`radio mr-1 h-6 w-6 cursor-pointer ${
                    payment.checked ? 'bg-checkedRoundIcon' : 'bg-checkRoundIcon'
                  }`}
                  type="radio"
                  id={String(index)}
                  checked={payment.checked}
                  value={payment.value}
                  onChange={onChangePaymentMethod}
                />
                {payment.value}
              </label>
            ))}
          </div>
        </div>
      </ProcessContent>
      <div className="relative">
        <ProcessFooter onClick={onClickPayment} buttonText={footerText} />
      </div>
    </div>
  )
}

export default PurchasePayment
